import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import logo from "../../../../src/assets/substratum-protocol/logo-substratum-protocol.webp";

import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./substratum-protocol-styles.scss";
import earthBreaking from "../../../../src/assets/substratum-protocol/session01/00-the-earth-is-breaking.webp";
import callToAction from "../../../../src/assets/substratum-protocol/session01/01-call-to-action.webp";
import fractureObservatory from "../../../../src/assets/substratum-protocol/session01/02-fracture-observatory.webp";
import registration from "../../../../src/assets/substratum-protocol/session01/03-the-registration.webp";
import drAlmeida from "../../../../src/assets/substratum-protocol/session01/04-meeting-dr-almeida.webp";
import descent from "../../../../src/assets/substratum-protocol/session01/05-the-descent.webp";
import unBrief from "../../../../src/assets/substratum-protocol/session01/united-nations-brief.webp";
import fracture from "../../../../src/assets/substratum-protocol/session01/the-fracture-brazil.webp";
import sector01 from "../../../../src/assets/substratum-protocol/session01/sector-01-map-card-fracture-opening.webp";
import sector01Scene from "../../../../src/assets/substratum-protocol/session01/sector-01-mood-fracture-opening.webp";
import powerfulCreatures from "../../../../src/assets/substratum-protocol/session01/sector-01-encounter-powerful-territorial-creatures.webp";
import clue46 from "../../../../src/assets/substratum-protocol/session01/anomoly-clue-46.webp";
import clue53 from "../../../../src/assets/substratum-protocol/session01/anomoly-clue-53.webp";
import sector02 from "../../../../src/assets/substratum-protocol/session01/sector-02-map-civilization-ruins.webp";
import sector02Scene from "../../../../src/assets/substratum-protocol/session01/sector-02-mood-civilization-ruins.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "1",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Carter One",
  backgroundColor: "rgba(0, 0, 0, 1) ",
  color: "white",
  marginBottom: "15px",
};

const SPSession01 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body) => {
    setModalData({
      body: body,
      image: img,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };
  const section1Data = [
    {
      title: "",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",
      text: (
        <div className="substratumProtocolBodyText">
          {/* <ImageComponent
            image={logo}
            caption="Gomsten Island"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody={renderToStaticMarkup(<ScientistProfile />)}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent> */}
          <p>
            <h3 style={{ color: "#c47768" }}>
              WARNING: session notes for Substratum Protocol contains spoilers.
              While the envisioning of the sectors, hazards, and understandings
              are unique to our group, please do not read if you want to
              encounter the game without any prior knowledge.
            </h3>
          </p>
          <p>
            For days, something has been happening beneath the Earth. Ground
            shocks are being detected across the globe. Subsurface fractures are
            spreading, volcanoes are becoming increasingly active, and entire
            sections of ground are collapsing. In some places, oceans are
            draining into the depths. Then the instruments began reporting
            things that shouldn't be possible.
          </p>
          <p>
            <img
              src={earthBreaking}
              alt="The Earth is Breaking"
              className="imageWrapper"
            />
          </p>
          <p>
            Gravity is fluctuating. The electromagnetic field is failing.
            Satellites are going offline. Even the orbits of the Moon and Sun
            are changing. No one knows why. Governments and scientific
            institutions worldwide have redirected their resources toward
            understanding the phenomenon. And now, your particular field of
            expertise has become part of that effort.
          </p>
          <p>
            <em>
              What is your scientist's name? Where are they from and where do
              they live? What is your scientific expertise in this context?
            </em>
          </p>
          <a href="#pageTop">Back to Top</a>
          <p>
            <img
              src={callToAction}
              alt="Call to Action"
              className="imageWrapper"
            />
          </p>
          <p>
            The call comes without warning. A government agent in a dark suit
            arrives at your workplace with a simple message:
          </p>
          <ImageComponent
            image={unBrief}
            caption="UN Brief"
            cssClass="imageLeft"
            handleClick={handleClick}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={fracture}
            caption="The Fracture"
            cssClass="imageRight"
            handleClick={handleClick}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <p>
            <font style={{ fontStyle: "italic", color: "#e6c02e" }}>
              “You've been selected for an emergency scientific response. You
              need to come with us.”
            </font>
          </p>
          <p>
            There is no time to prepare. No time to say goodbye. Minutes later,
            you are aboard a military VTOL bound for South America.
          </p>
          <p>
            <font style={{ fontStyle: "italic", color: "#e6c02e" }}>
              “You've been identified as essential personnel for the Substratum
              Protocol. Earth needs you.”
            </font>
          </p>
          <p>
            <strong>
              Before receiving your briefing, each player answers three
              questions from the Personnel Questionnaire.
            </strong>
          </p>
          <p>
            Then the briefing materials are placed in your hands: an United
            Nations briefing packet and a detailed breakdown of a nightmarish
            chasm known as The Fracture. The fracture is tearing Brazil apart.
          </p>
          <a href="#pageTop">Back to Top</a>
          <p>
            <p>
              The VTOL has been flying for hours. And then, the landscape below
              becomes almost impossible to recognize.
            </p>

            <p>
              The Paraná Basin has become a vast scar across the Earth. The
              ground drops away into an enormous fissure stretching toward the
              horizon, its depths obscured by smoke, dust, and a dull red glow.
              The pilot's voice comes over the cabin speakers.
            </p>

            <p>
              <font style={{ fontStyle: "italic", color: "#e6c02e" }}>
                “We're approaching our destination.” You'll want to look out the
                left side. Home sweet home for now.”
              </font>
            </p>
            <p>
              <img
                src={fractureObservatory}
                alt="Fracture Observatory"
                className="imageWrapper"
              />
            </p>
            <p>
              Suspended above the gaping chasm in the Earth is the Fracture
              Observatory: a massive circular facility hangs over the center of
              the rupture, held in place by enormous tension lines anchored far
              out across the surrounding terrain.
              <br />
              At its center, a long mechanical structure disappears straight
              down into the Fracture.
            </p>

            <p>The pilot continues:</p>

            <p>
              <font style={{ fontStyle: "italic", color: "#e6c02e" }}>
                “That's Mission Control. We're docking on the upper ring.
                Welcome to the Fracture Observatory.”
              </font>
            </p>

            <p>
              As the VTOL approaches, your escort finally removes their
              sunglasses.
            </p>
            <p>
              <font style={{ fontStyle: "italic", color: "#e6c02e" }}>
                “The ring you're looking at is the operational center of the
                Observatory. Laboratories, communications, medical facilities,
                life support, command operations. Everything needed to keep the
                expedition running.”
              </font>
            </p>

            <p>
              They point toward the enormous structure descending beneath the
              facility.
            </p>

            <p>
              <font style={{ fontStyle: "italic", color: "#e6c02e" }}>
                “That is the descent spindle.” It is your route into the
                Fracture. Eventually, you'll be going all the way down.”
              </font>
            </p>

            <p>The VTOL settles on the docking platform.</p>

            <p>
              <font style={{ fontStyle: "italic", color: "#e6c02e" }}>
                “For now, you're going to meet Dr. Fernando Marques de Almeida.
                He'll explain the rest. Until then, you should understand one
                thing: the mission is the priority.”
              </font>
            </p>
          </p>
          <a href="#pageTop">Back to Top</a>
          <p>
            Then we take a break to have players assign their d10, d8, and d6
            dice to their skills.
            <br /> We go over how actions work and card mechanics.
          </p>
          <p>
            <img
              src={registration}
              alt="The Registration"
              className="imageWrapper"
            />
          </p>
          <a href="#pageTop">Back to Top</a>

          <p>
            The players meet in corridors of the Observatory, guided by their
            escort. Inside a meeting room, they are introduced to Dr. Fernando
            Marques de Almeida.
          </p>
          <p>
            Dr. Almeida is a distinguished scientist with extensive experience
            in the field. He welcomes the players and provides an overview of
            the mission and the challenges they will face in the Fracture.
          </p>
          <p>
            <font style={{ fontStyle: "italic", color: "#e6c02e" }}>
              Welcome to the Fracture Observatory. It was built very quickly,
              and under circumstances I would normally consider completely
              unacceptable. Unfortunately, we no longer have the luxury of
              normal circumstances.
            </font>
          </p>
          <p>
            <font style={{ fontStyle: "italic", color: "#e6c02e" }}>
              Five thousand seven hundred and thirty-four kilometers to the
              Earth's core where the anamoly has appeared.
              <br />
              Since then, the planet has begun behaving in ways that geology
              cannot explain.”
            </font>
          </p>
          <p>
            <img src={drAlmeida} alt="Dr. Almeida" className="imageWrapper" />
          </p>
          <p>
            <font style={{ fontStyle: "italic", color: "#e6c02e" }}>
              Ground shocks. Subsurface fractures. Gravitational fluctuations.
              Electromagnetic failure. Changes in the solar orbit. Changes in
              the lunar orbit.
              <br />
              And our sensors are becoming less reliable the closer we look.
              <br />
              We have sent probes down. Their data comes back scrambled.
              Sometimes contradictory. Sometimes completely meaningless.
              <br />
              Three of our scientists became unresponsive while attempting to
              interpret the transmissions.
              <br />
              So we are going to stop asking the instruments what is happening.
            </font>
          </p>
          <p></p>
          <p>His eyes move from scientist to scientist.</p>
          <p>
            <font style={{ fontStyle: "italic", color: "#e6c02e" }}>
              You were selected because you are among the best scientists we
              have left.
              <br />
              The world above us is already changing. People are frightened.
              Cities are being damaged. We don't know how much time we have.
              <br />
              So descend.
              <br />
              Learn.
              <br />
              And survive long enough to tell us what you find.
            </font>
          </p>

          <a href="#pageTop">Back to Top</a>
          <p>
            We cover exosuit rules and the players choose their starting item.
            And then, they descend into the Fracture.
          </p>
          <p>
            <img src={descent} alt="The Descent" className="imageWrapper" />
          </p>
        </div>
      ),
    },
  ];

  const section2Data = [
    {
      title: "SECTOR 01: THE FRACTURE",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",
      text: (
        <div className="substratumProtocolBodyText">
          {/* <ImageComponent
            image={logo}
            caption="Gomsten Island"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody={renderToStaticMarkup(<ScientistProfile />)}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent> */}

          <p>
            <img src={sector01} alt="Sector 01 HUD" className="imageWrapper" />
          </p>
          <p>
            Burn and Moshe arrive at the "bottom" of the fracture.
            Communications with Mission Control are already failing. They hear
            an odd ringing sound; a female voice over their exosuit speakers.
            She sounds far away:
          </p>
          <p>
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “The terrors and sounds of the world above subside as we travel
              lower past the fissure's edge.”
            </font>
          </p>
          <p>
            The scientists look at each other, unsure of what to make of the
            voice. Burns shakes his head, trying to focus on the task at hand.
            Moshe tries to raise Mission Control on comms:
          </p>
          <p>
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Mission Control, do you copy? We have reached the bottom of the
              fracture. Was that you just now? Hello? Nothing. Damn.”
            </font>
          </p>
          <p>
            <img
              src={sector01Scene}
              alt="The Earth is Breaking"
              className="imageWrapper"
            />
          </p>
          <p>
            The scientists exchange uneasy glances, the eerie voice still
            echoing in their minds. They continue their journey, eventually
            coming to an open cavern, a massive vista like nothing ever seen.
          </p>
          <p>
            Burn's beepbobop runs ahead while Moshe's lags, both recon droids
            scanning. Burn's beepbobop signals back with a series of rapid
            beeps, indicating it has found something of interest, something
            moving.
          </p>
          <p>
            Moshe senses danger and sets up his laser gattling gun. <br />A trio
            of large, territorial creatures emerges from the shadows, their eyes
            glowing with a predatory intensity. Their backs are covered with
            crystals. While wolflike, it's clear they are no species found on
            Earth; not on the surface anyhow. With a startled mutter, Moshe
            let's fly with the gattling laser.
          </p>
          <p>
            <img
              src={powerfulCreatures}
              alt="Powerful Territorial Creatures"
              className="imageWrapper"
            />
          </p>
          <p>
            The player for Moshe burns 2 stress for the roll and it's GOOD. The
            lasers richochet off the crystalline backs of the creatures,
            scattering light in all directions. One of the creatures falls, it's
            hide smoking, while the rest flee into the darkness of the cavern.
          </p>
          <p>
            Moshe and Burns both breathe a sigh of relief. Moshe takes a STUDY
            action on the wolf. As he dissects the unearthy animal, he has a
            vision
          </p>
          <p>
            He sees a strang, alien altar of some kind, its surface etched with
            symbols that pulse with an otherworldly light. There is a suspended
            whirl of rock and materials, spinning and gathering other matter to
            it.
          </p>
          <p>
            Moshe rolls to UNDERSTAND and fail. He has a flashback where he
            seems to be running around the altar and the spinning force for
            hours, perhaps days. The flashback fails also and Moshe takes two
            more stress and hands the anomoly clue to Burns by way of broken,
            jabbering descriptions of what he has seen.
          </p>
          <p>
            Moshe sits to rest, suffering FRAGILE LAWS level of anomoly effects.
            Meanwhile, Burns rolls UNDERSTAND and understands the clue.
          </p>
          <p>
            <img src={clue53} alt="Clue 53" className="imageWrapper" />
          </p>
          <p>
            The understanding for CLUE 53 is that the altar is functioning as a
            device to gather gravitational force, almost like a resource; like
            one might have a water resevoir, this device must be filling
            something with gravity.
          </p>
          <p>
            Burns helps Moshe to his feet. He rolls TRAVEL with an OK result.
            Some damage and a complication, but they make it to SECTOR 02.
          </p>
          {/* import sector01 from "../../../../src/assets/substratum-protocol/session01/sector-01-map-card-fracture-opening.webp";
import sector01Scene from "../../../../src/assets/substratum-protocol/session01/sector-01-mood-fracture-opening.webp";
import powerfulCreatures from "../../../../src/assets/substratum-protocol/session01/sector-01-encounter-powerful-territorial-creatures.webp";
import clue46 from "../../../../src/assets/substratum-protocol/session01/anomoly-clue-46.webp";
import clue53 from "../../../../src/assets/substratum-protocol/session01/anomoly-clue-53.webp"; */}

          <p>The VTOL settles on the docking platform.</p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];
  const section3Data = [
    {
      title: "SECTOR 02: CIVILIZATION RUINS",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",
      text: (
        <div className="substratumProtocolBodyText">
          {/* <ImageComponent
            image={logo}
            caption="Gomsten Island"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody={renderToStaticMarkup(<ScientistProfile />)}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent> */}
          <p>descent</p>
          {/* import sector01 from "../../../../src/assets/substratum-protocol/session01/sector-01-map-card-fracture-opening.webp";
import sector01Scene from "../../../../src/assets/substratum-protocol/session01/sector-01-mood-fracture-opening.webp";
import powerfulCreatures from "../../../../src/assets/substratum-protocol/session01/sector-01-encounter-powerful-territorial-creatures.webp";
import clue46 from "../../../../src/assets/substratum-protocol/session01/anomoly-clue-46.webp";
import clue53 from "../../../../src/assets/substratum-protocol/session01/anomoly-clue-53.webp"; */}
          <p>
            <img src={sector02} alt="Sector 02 HUD" className="imageWrapper" />
          </p>
          <p>
            Burn and Moshe travel toward SECTOR 02. Again they hear an odd
            ringing sound and the same female voice over their exosuit speakers.
            She sounds less far away this time:
          </p>
          <p>
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “As we venture further than we ever have before, we stumble upon a
              discovery that leaves us picking our jaws off the floor.
              <br />
              We have found ruins that seem to predate the first homo sapiens.”
            </font>
          </p>
          <p>
            <img
              src={sector02Scene}
              alt="Civilization Ruins"
              className="imageWrapper"
            />
          </p>
          <p>
            The scientists are excited and awestruck by the ancient ruins they
            have discovered, and earger to learn more. They come to an area
            filled with tunnels and ancient transportation ruins. Some of the
            abandoned structures were likely vehicles and they see rails that
            seem very similar to what is found above. Beepbobop scouting ahead
            finds an shimmering cloud of particles in the air. Burns studies the
            data and realizes the nanoparticles, when graphed, are clearly a
            smell of some kind. A smell that tries to create memories that are
            not your own.
          </p>
          <p>
            <img src={clue46} alt="Clue 46" className="imageWrapper" />
          </p>
          <p>
            After a good study roll, the clue is understood. The understanding
            of CLUE 46 is that humans need to inhabit an alien way of thinking.
            The scent bends deepest memory in service to understanding an alien
            consciousness we need commune with. Or perhaps the smell is less
            than an invitation to a new way of thinking and is instead a tool to
            change and conform unwilling consciousnesses?
          </p>
          <p>
            This is where we end: Moshe has THRUMMING WHISPERS from stress
            damage, and the pair of intrepid explorers have two anomoly clues
            that they have understood. They are still in SECTOR 02 with much
            more to explore, understand, and survive.
          </p>
          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  useEffect(() => {
    // document.body.style.backgroundImage = `url(${require("../../../../src/assets/forbidden-lands/fbl-page-background-blizzard.webp")})`;
    document.body.style.backgroundColor = "#c47768";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      {/* <iframe sandbox="allow-popups allow-scripts allow-modals allow-forms allow-same-origin" 
                    style={{position: 'float', float: 'right',width: '120px', height: '240px'}} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=smokeraven-20&language=en_US&marketplace=amazon&region=US&placement=9189143701&asins=9189143701&linkId=d1384e0e6b9ef083fee35d7272a71f88&show_border=true&link_opens_in_new_window=true"></iframe> */}
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "IM Fell Great Primer",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={logo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Substratum Protocol campaign"
                  />
                </a>
              </main>
              <h1 className="cover-heading">THE EARTH IS BREAKING</h1>
              <h4>Substratum Protocol Session 01</h4>
              {/* <p className="lead leadExtra">
                <BRSubNav />
              </p> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title
                id="cardTitle-substratum-protocol"
                className="cardTitle-substratum-protocol"
              >
                <span
                  style={{
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  The Earth is breaking and two scientists are summoned to
                  descend into The Fracture to learn about The Anomaly.
                </span>
                <br />

                <small>
                  <span className="emoji" role="img" aria-label="lab coat">
                    🥼
                  </span>
                  <a href="./substratum-protocol-scientist-profile-moshe-mazel">
                    Dr. Moshe Mazel
                  </a>
                  <span className="emoji" role="img" aria-label="lab coat">
                    🥼
                  </span>
                  <a href="./substratum-protocol-scientist-profile-burnstein-grok">
                    Dr. Burnstein Grok
                  </a>
                  <span className="emoji" role="img" aria-label="earth">
                    🌎
                  </span>
                  Session 01: The Earth is Breaking
                  <span className="emoji" role="img" aria-label="earth">
                    🌎
                  </span>
                  <a href="./substratum-protocol-session-02">
                    Session 02: The Star in the Jar
                  </a>
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
              <div>
                <ContentContainer data={section2Data} />
              </div>
              <div>
                <ContentContainer data={section3Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SPSession01;
